import React, { Component } from "react";
import { notification, message, Spin } from 'antd';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);



export default class PacDiabetes extends Component {

  state = {
    labels:[],
    values: [],
    loading: false
  }

  componentDidMount(){

    const { unidad_medica_user, periodo, backend } = this.props;

    fetch(`${backend}/pacientediabetesV2/unidad/${unidad_medica_user}/periodo/${periodo}`,
      {
          method: "GET",
          headers: {
              'Access-Control-Allow-Origin': '*'
          }
      }).then((res) => {
          return res.json();
      }).then((data) => {
          this.setState({
            labels: data.data.labels,
            values: data.data.values,
            loading:true
          });
      }).catch((error) => {
          console.log(error);
          notification.error({
              message: 'Error',
              description: "Ocurrió un error al obtener los pacientes con diabetes",
          });
          message.destroy()
      });

  }

  render(){

    const { labels, values, loading } = this.state;

    const options = {
      indexAxis: 'y',
      responsive: true,
      plugins:[ChartDataLabels],
      plugins: {
        legend: {
          display: false,
          position: 'top',
        },
        title: {
          display: false,
          text: 'Riesgo Obtétrico',
          font:{
            size:'28'
          }
        },
        datalabels:{
          color: '#ffffff',
          font: {
            weight: 'bold',
            size: '15'
          }
        }
      },
    };
    
    const data = {
      labels,
      // labels: ["9 a 17", "18 a 29", "30 a 40", "41 a 59"],
      datasets: [
        {
          // label: 'Dataset 1',
          // data: [8, 6, 1, 13 ],
          data: values,
          backgroundColor: [
            'rgb(69, 114, 196, 1)',
            'rgb(69, 114, 196, 1)',
            'rgb(69, 114, 196, 1)',
            'rgb(69, 114, 196, 1)',
            'rgb(69, 114, 196, 1)',
          ],
        }
      ],
    };

    return(
      loading ?
        <Bar 
        width={600}
        height={150}
        options={options} 
        data={data} 
        />
        : <Spin size="small"/>
    );
  }
}
